// import style
import "swiper/css/swiper.css";

import App from "./App.vue";
import Decode from "@/utils/Decode";
import SlideUpDown from "vue-slide-up-down";
// https://vcalendar.io/examples/datepickers.html
import VCalendar from "v-calendar";
import Vue from "vue";
import VueFilterDateFormat from "@vuejs-community/vue-filter-date-format";
import { VueMasonryPlugin } from "vue-masonry";
import VueSmoothScroll from "vue2-smooth-scroll";
import router from "./router";
import { setup } from "axios-cache-adapter";
import store from "./store";

Vue.use(VueFilterDateFormat);

Vue.component("slide-up-down", SlideUpDown);

Vue.use(VueSmoothScroll);

Vue.use(VueMasonryPlugin);

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: "v" // Use <vc-calendar /> instead of <v-calendar />
});

Vue.config.productionTip = false;

// let base_url = '/';
// if (process.env.NODE_ENV === 'development') base_url = 'http://test5.twelve.la/charleston/';
///wp-json/cocart/v1/add-item
const ajax = setup({
  baseURL: window.globals.api_url,
  cache: {
    maxAge: 20 * 60 * 1000, // 20min
    exclude: {
      query: false
    }
  }

  // withCredentials: true,

  // headers: {
  //     'x-requested-with': 'XMLHttpRequest',
  // },
});

const cart = setup({
  baseURL: window.globals.home_url + "/wp-json/cocart/v1/",
  cache: {
    maxAge: 0, // 20min
    exclude: {
      query: false
    }
  },
  withCredentials: true,
  withAuthorization: true

  // headers: {
  //     'X-CoCart-API': 'b65adb32c53c897f5426b44faee995af',

  // },
});

Vue.prototype.decode = Decode;
Vue.prototype.$ajax = ajax;
Vue.prototype.$cart = cart;

// Vue.prototype.isDesktop = device('desktop');
// Vue.prototype.isTablet = device('tablet');
// Vue.prototype.isMobile =  device('mobile');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
